import firebase from 'firebase/app'
import 'firebase/firestore'

var FIREBASE_CONFIG = {
  apiKey: "AIzaSyAN0IXHvhXGJ0Laahpn2Z32x3XxGh3pFKQ",
  authDomain: "car-dashboard-others.firebaseapp.com",
  databaseURL: "https://car-dashboard-others.firebaseio.com",
  projectId: "car-dashboard-others",
  storageBucket: "car-dashboard-others.appspot.com",
  messagingSenderId: "399290790798"
};

firebase.initializeApp(FIREBASE_CONFIG);
const firestore = firebase.firestore();


// in the future, users will be able to edit their comments
// const auth = firebase.auth()
// const currentUser = auth.currentUser

// we will remove local storage soon and use offline persistence
// firestore.enablePersistence()
//   .then(function() {
//       // Initialize Cloud Firestore through firebase
//       var db = firestore;
//   })
//   .catch(function(err) {
//       if (err.code == 'failed-precondition') {
//           // Multiple tabs open, persistence can only be enabled
//           // in one tab at a a time.
//           // ...
//       } else if (err.code == 'unimplemented') {
//           // The current browser does not support all of the
//           // features required to enable persistence
//           // ...
//       }
//   });
const settings = {/* your settings... */ timestampsInSnapshots: true};
firestore.settings(settings);


export const db = firestore;



// WEBPACK FOOTER //
// ./src/assets/js-on/firebaseConfig.js